import { userInteraction } from './events-manager';
import { UserInteractions } from './system-types';

const publishUserInteractionEvent = (type: UserInteractions, event: Event) => {
  userInteraction.next({
    type,
    data: {
      eventType: event.type,
      eventTarget: event.target as HTMLElement,
      eventTargetDataset: (event.target as HTMLElement).dataset,
      eventTargetNodeName: (event.target as HTMLElement).nodeName,
      event: event,
    },
  });
};

const onClick = (event: MouseEvent) => {
  publishUserInteractionEvent(UserInteractions.CLICK, event);
};

const onScroll = (event: WheelEvent) => {
  publishUserInteractionEvent(UserInteractions.WHEEL, event);
};

/**
 * Adds event listeners to the 'click' and 'wheel' events on the document
 */
export const addEventListeners = () => {
  document.addEventListener('click', onClick);
  document.addEventListener('wheel', onScroll);
};

/**
 * Removes event listeners from the 'click' and 'wheel' events on the document
 */
export const removeEventListeners = () => {
  document.removeEventListener('click', onClick);
  document.removeEventListener('wheel', onScroll);
};
